var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseTemplate',[_c('h2',{staticClass:"text-center mt-5"},[_vm._v("v1.13")])])
}
var staticRenderFns = []

export { render, staticRenderFns }